import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSpinnerIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_12242_30904",
		style: { maskType: "luminance" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 8,
		height: 8,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.5 0.5V7.5H0.5V0.5H7.5Z",
			fill: "white",
			stroke: "white"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_12242_30904)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M3.99992 0V2V0Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M3.99992 0V2",
				stroke: "currentColor",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .5,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M3.99992 8V6V8Z",
					fill: "currentColor"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M3.99992 8V6",
					stroke: "currentColor",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .9,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M1.64885 0.763672L2.82442 2.38171L1.64885 0.763672Z",
					fill: "currentColor"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M1.64885 0.763672L2.82442 2.38171",
					stroke: "currentColor",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .1,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M6.35098 0.763672L5.17538 2.38171L6.35098 0.763672Z",
					fill: "currentColor"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M6.35098 0.763672L5.17538 2.38171",
					stroke: "currentColor",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .4,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M6.35098 7.23665L5.17538 5.61865L6.35098 7.23665Z",
					fill: "currentColor"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M6.35098 7.23665L5.17538 5.61865",
					stroke: "currentColor",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .6,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M1.64885 7.23665L2.82442 5.61865L1.64885 7.23665Z",
					fill: "currentColor"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M1.64885 7.23665L2.82442 5.61865",
					stroke: "currentColor",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .2,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M7.80405 2.76367L5.90195 3.38171L7.80405 2.76367Z",
					fill: "currentColor"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M7.80405 2.76367L5.90195 3.38171",
					stroke: "currentColor",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .7,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M0.19574 5.23666L2.09785 4.61865L0.19574 5.23666Z",
					fill: "currentColor"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M0.19574 5.23666L2.09785 4.61865",
					stroke: "currentColor",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .3,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M7.80405 5.2367L5.90195 4.61865L7.80405 5.2367Z",
					fill: "currentColor"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M7.80405 5.2367L5.90195 4.61865",
					stroke: "currentColor",
					strokeLinejoin: "round"
				})]
			}),
			/* @__PURE__ */ _jsxs("g", {
				opacity: .8,
				children: [/* @__PURE__ */ _jsx("path", {
					d: "M0.19574 2.76367L2.09785 3.38171L0.19574 2.76367Z",
					fill: "currentColor"
				}), /* @__PURE__ */ _jsx("path", {
					d: "M0.19574 2.76367L2.09785 3.38171",
					stroke: "currentColor",
					strokeLinejoin: "round"
				})]
			})
		]
	})]
});
export default SvgSpinnerIcon;
